// extracted by mini-css-extract-plugin
module.exports = {"Skeleton":"Skeleton--25wMB","NeutralHeader":"NeutralHeader--odY6j","HighlightedHeader":"HighlightedHeader--2lzbQ"};